import { toast } from 'sonner';
import AppToast from '../components/common/AppToast';

export const toasterOptions = {
  position: 'top-right',
  expand: false,
  richColors: false,
  closeButton: false,
  duration: 4500,
  gap: 10,
  offset: 24,
  visibleToasts: 4,
  toastOptions: {
    unstyled: true,
    classNames: {
      toast: 'app-toast-item',
    },
  },
};

function showToast(type, message, title) {
  return toast.custom(
    (t) => (
      <AppToast
        type={type}
        title={title}
        message={message}
        onDismiss={() => toast.dismiss(t)}
      />
    ),
    { duration: 4500 }
  );
}

export function showSuccessToast(message, title) {
  return showToast('success', message, title);
}

export function showErrorToast(message, title) {
  return showToast('error', message, title);
}

export function showInfoToast(message, title) {
  return showToast('info', message, title);
}
